import { Link } from 'react-router-dom';

import { InfoBlock } from 'app/components/commons/InfoBlock/InfoBlock';
import type { BookingDetails } from 'app/typings/core/admin/bookings/booking';
import { formatHotelNameWithStars } from 'app/utils/hotels';
import { formatPaxAsString } from 'app/utils/pax';

type Props = {
  bookingDetails: BookingDetails;
};

export const Summary = ({ bookingDetails }: Props) => {
  const isDaytime = bookingDetails.pack.isDaytime;

  const pax = {
    adults: bookingDetails.adults,
    children: bookingDetails.children,
    babies: bookingDetails.babies,
  };

  const room = bookingDetails.rooms[0];

  return (
    <InfoBlock
      title="Summary"
      rows={[
        {
          label: 'Hotel',
          value: bookingDetails.hotel.name ? (
            <Link
              to={
                '/hotels/' +
                bookingDetails.hotel.id +
                '/edit?tab=contacts&section=guest-relation-contact'
              }
              target="_blank"
            >
              {formatHotelNameWithStars(
                bookingDetails.hotel.name,
                bookingDetails.hotel.stars
              )}
            </Link>
          ) : (
            '-'
          ),
        },
        {
          label: isDaytime ? 'Daytime package' : 'Night stay package',
          value: (
            <Link to={'/packs/' + bookingDetails.pack.id} target="_blank">
              {bookingDetails.pack.nameForUser ??
                bookingDetails.pack.nameForHotel}
            </Link>
          ),
        },
        {
          label: 'Guest',
          value: formatPaxAsString(pax),
        },
        { label: 'Room category', value: room?.categoryName },
        {
          label: 'Room name',
          value: room && (room.name ?? '-'),
        },
      ]}
    />
  );
};
